import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import * as momentTz from 'moment-timezone';
import { Subscription } from 'rxjs';
import { ConfigService } from 'src/app/config/config.service';
import { clubInterviewEventTypes, playersTypes } from 'src/app/helpers/fixture-helper';
import { Roles } from 'src/app/models/enums';
import { LocationTypeDto, PlayerDto, LocationDto, CreateLocationDto, IInterviewEventDetailsDto, InterviewEventType, InterviewEventRequestSlotDto, Players } from 'src/app/services/bpp.webapi/client';
import { AppState } from 'src/app/store/app.state';
import { GetLocationTypesAction } from 'src/app/store/location-types/actions';
import { GetLocationsAction, CreateLocationAction } from 'src/app/store/location/actions';
import { AddLocationComponent } from '../../common/add-location/add-location.component';
import * as helper from '../../../helpers/date-helper';
import { getEmptyGuid } from 'src/app/helpers/common';

@Component({
  selector: 'app-club-interview-body',
  templateUrl: './club-interview-body.component.html',
  styleUrls: ['./club-interview-body.component.scss']
})
export class ClubInterviewBodyComponent implements OnInit, OnDestroy, OnChanges {

  locationSubscription: Subscription;
  eventModel: IInterviewEventDetailsDto = null;
  locationTypesSubscription: Subscription;
  locationTypes: LocationTypeDto[];
  isLeagueMode: boolean;

  minDate = {
    year: moment().utc().year(),
    month: moment().utc().month(),
    day: moment().utc().date()
  };
  maxDate = {
    year: moment().utc().year(),
    month: moment().utc().month(),
    day: moment().utc().date()
  };

  startDate: moment.Moment;
  arrivalTime: moment.Moment;
  duration: moment.Moment;
  startTime: moment.Moment;

  @Output() modelChange: EventEmitter<IInterviewEventDetailsDto> = new EventEmitter<IInterviewEventDetailsDto>();
  @Input() isReadOnly: boolean;
  @Input() players: PlayerDto[];
  @Input() isPastInterview: boolean;
  @Input() teamId: number;
  @Input() matchDate:moment.Moment;
  interviewEventTypes = clubInterviewEventTypes;
  pTypes = playersTypes;


  @Input()
  get clubInterviewEvent(): IInterviewEventDetailsDto {
    return this.eventModel;
  }
  set clubInterviewEvent(value) {
    if (!value) {
      this.eventModel = value;
      return;
    }

    this.eventModel = {
      ...value,
      slots: value.slots || [], 
      duration: value.duration 
          
        
    };

    this.initializeTimeProperties();
  }

  @Output() clubInterviewEventChange = new EventEmitter<IInterviewEventDetailsDto>();
  private emitChanges() {
    this.modelChange.emit(this.eventModel);
    this.clubInterviewEventChange.emit(this.eventModel); 
  }

  private initializeTimeProperties() {
    if (this.eventModel) {
      this.startDate = moment(this.eventModel.startUtc);
      this.startTime = moment(this.eventModel.startUtc);
      this.arrivalTime = moment(this.eventModel.arrivalUtc);
      const tmpDuration = moment.duration(this.eventModel.duration.asMinutes() - momentTz.tz(this.timezone).utcOffset(), 'minutes');
      this.duration = moment().utc().startOf('day').add(tmpDuration );
    }
  }

  @Input() userRole: Roles;

  selectedLocation: LocationDto;
  locations: LocationDto[];
  modalSubscription;
  isLog = false;
  timezone :string;
  isLfp:boolean;

  constructor(private store: Store<AppState>,
    private modalService: NgbModal,
    config: ConfigService) {
   this.timezone = config.get('defaultTimeZone');
    this.isLog = config.isDebug();
    this.isLfp = config.isLfp();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes && changes.clubInterviewEvent && changes.clubInterviewEvent.currentValue) {
      const evt = changes.clubInterviewEvent.currentValue;
      const updatedSlots = (evt.slots || []).map(slot => {
        const duration = moment.duration(slot.endTime.diff(slot.startTime, 'milliseconds'), 'milliseconds');

         const slotInstance = new InterviewEventRequestSlotDto({
        ...slot,
        duration: {
          hour: duration.hours(),
          minute: duration.minutes()
        }
      });
        return slotInstance;
      });

      this.eventModel = {
        ...evt,
        slots: updatedSlots
      };
    }
  }

  ngOnInit() {
    if (this.isLog) { console.log('Club-Interview-body init:', this.eventModel); }

    this.minDate = helper.getMinDate(this.eventModel.arrivalUtc);
    this.maxDate = this.isLfp ? helper.getLfpMaxDate(this.matchDate) : helper.getMaxDate(this.eventModel.arrivalUtc);

    this.isLeagueMode = this.userRole === Roles.League || this.userRole === Roles.Admin;

    this.locationSubscription = this.store
      .select(e => e.location.items)
      .subscribe(res => {
        if (res && res.length > 0) {
          this.locations = res;
          this.selectedLocation = this.locations.find(x => x.locationId === this.clubInterviewEvent.location.locationId);
          this.store.dispatch(new GetLocationTypesAction());
        }
      });
    this.store.dispatch(new GetLocationsAction(this.teamId));
    this.store.dispatch(new GetLocationTypesAction());
  }

  findWithAttr(array, attr, value) {
    for (let i = 0; i < array.length; i += 1) {
      if (array[i][attr] === value) {
        return i;
      }
    }
    return -1;
  }

  initNewPlayer(model) {
    const player = new PlayerDto();
    player.init(model);
    return player;
  }

  concatDate(date: moment.Moment, time: moment.Moment) {
    const h = time.hour();
    const m = time.minute();
    const result = moment(date, 'YYYY-MM-DD').hour(time.hour()).minute(time.minute());
    const str = result.format('YYYY-MM-DD HH:mm');
    return result;
  }

  printLog(what) {
    if (this.isLog) {
      console.log(`${what} changed`);
      console.log(`[arrival]:`, this.eventModel.arrivalUtc.toISOString());
      console.log(`[start]:`, this.eventModel.startUtc.toISOString());
      console.log(`[duration]:`, this.eventModel.duration.toISOString());
    }
  }

  onLocationChanged(newLocation: LocationDto) {
  
  if (!newLocation) return;
  
  const previousModel = this.eventModel;
  
  this.eventModel = {
    ...this.eventModel,
    location: newLocation,
    slots: this.eventModel.slots || []
  };
  this.emitChanges();
}

  dateChanged(e: moment.Moment) {
    this.startDate = e;
    this.arrivalTime = this.concatDate(e, this.arrivalTime);
    this.startTime = this.concatDate(e, this.startTime);
    
    this.eventModel = {
      ...this.eventModel,
      arrivalUtc: this.concatDate(e, this.arrivalTime),
      startUtc: this.concatDate(e, this.startTime),
      slots: this.eventModel.slots || []
    };
    
    this.printLog('Interview Date');
    this.emitChanges(); 
  }

  arrivalTimeChanged(time: moment.Moment) {
    this.arrivalTime = this.concatDate(this.startDate, time);
    
    this.eventModel = {
      ...this.eventModel,
      arrivalUtc: this.concatDate(this.startDate, time),
      slots: this.eventModel.slots || []
    };
    
    this.printLog('Interview Arrival');
    this.emitChanges();
  }

  startTimeChanged(time: moment.Moment) {
    this.startTime = this.concatDate(this.startDate, time);
    
    this.eventModel = {
      ...this.eventModel,
      startUtc: this.concatDate(this.startDate, time),
      slots: this.eventModel.slots || []
    };
    
    this.printLog('Interview Start');
    this.emitChanges();
  }

  durationChanged(time: moment.Moment) {
    this.duration = time;
    const tmpDate =  time.clone().tz(this.timezone)
    this.eventModel = {
      ...this.eventModel,
      duration: moment.duration({
        hours: tmpDate.hours(),
        minutes: tmpDate.minutes(),
        seconds: tmpDate.seconds()
      }),
      slots: this.eventModel.slots || []
    };
    
    this.printLog('Interview Duration');
    this.emitChanges();
  }

  openAddLocation() {
    const modalRef = this.modalService.open(AddLocationComponent);
    this.modalSubscription = modalRef.componentInstance.save.subscribe(location => this.saveLocation(location));
  }

  saveLocation(location: CreateLocationDto) {
    this.store.dispatch(new CreateLocationAction(location));
    this.store.dispatch(new GetLocationsAction(location.clubId));
    this.modalSubscription.unsubscribe();
  }

  changeLanguages(languages) {
    this.eventModel = {
      ...this.eventModel,
      languages: languages,
      slots: this.eventModel.slots || []
    };
    this.emitChanges(); 
  }

  changeSlotLanguages(languages, slotIndex) {
    const updatedSlots = this.eventModel.slots.map((slot, i) => 
      i === slotIndex 
        ? new InterviewEventRequestSlotDto({ ...slot, languages: languages })
        : new InterviewEventRequestSlotDto(slot)
    );
    
    this.eventModel = {
      ...this.eventModel,
      slots: updatedSlots
    };
    
    this.emitChanges(); 
  }

  addSlot() {
    const startTime = moment(this.eventModel.slots.length > 0 ? this.eventModel.slots[this.eventModel.slots.length - 1].endTime : this.eventModel.startUtc).utc();
    const endTime = moment(startTime).add(10, 'minutes').utc();
    
    const newSlot = new InterviewEventRequestSlotDto({
      id: getEmptyGuid(),
      requestId: null,
      startTime: startTime,
      endTime: endTime,
      languages: [],
      peoples: []
    });

    this.eventModel = {
      ...this.eventModel,
      slots: [...this.eventModel.slots, newSlot]
    };
    
    this.emitChanges(); 
  }

  firstSlotStartChanged(time: moment.Moment) {
    this.slotChanged(time, 0, 'startTime');
  }

  slotChanged(time: moment.Moment, index: number, prop: string) {
    const updatedSlots = this.eventModel.slots.map((slot, i) => {
      if (i === index) {
        const updatedSlot = new InterviewEventRequestSlotDto({ ...slot, [prop]: time });
        (updatedSlot as any).duration = moment().utc().startOf('day').add(
          moment.duration(updatedSlot.endTime.diff(updatedSlot.startTime, 'milliseconds'), 'milliseconds')
        );
        return updatedSlot;
      }
      return slot;
    });

    this.eventModel = {
      ...this.eventModel,
      slots: updatedSlots
    };
    
    this.emitChanges(); 
  }

  removeSlot(i: number) {
    const updatedSlots = this.eventModel.slots.filter((_, index) => index !== i);
    
    this.eventModel = {
      ...this.eventModel,
      slots: updatedSlots
    };
    
    this.emitChanges(); 
  }


  getInterviewICSSettingTypeText(val: number) {
    if (val !== undefined && this.locationTypes) {
      return this.locationTypes.find(x => x.id === val).name;
    }
    return '';
  }

  getInterviewEventTypeText(val: number) {
    if (val !== undefined) {
      return this.interviewEventTypes.find(x => x.key === val).name;
    }
    return '';
  }

  getPlayersText(val: Players) {
    if (val !== undefined) {
      return this.pTypes.find(x => x.key === val).name;
    }
    return '';
  }

  onChangeInterviewType(item: { key: number; name: string }) {
    this.eventModel = {
      ...this.eventModel,
      interviewType: item.key,
      //duration: this.eventModel.duration,
      slots: []
    };
    
    if (this.eventModel.interviewType === 1) {
      this.addSlot();
    }
    
    //this.duration = moment().utc().startOf('day').add(this.eventModel.duration);
    this.emitChanges(); 
  }

  onChangeEventPlayers(items) {
    this.eventModel = {
      ...this.eventModel,
      peoples: items
  };
  this.emitChanges();
}

  onChangePlayers(items, slotIndex) {
    const updatedSlots = this.eventModel.slots.map((slot, i) => 
    i === slotIndex 
      ? new InterviewEventRequestSlotDto({ ...slot, peoples: items })
      : slot
  );
  
  this.eventModel = {
    ...this.eventModel,
    slots: updatedSlots
  };
  
  this.emitChanges();
  }

  onChangePlayersType(item) {
    const updatedSlots = (this.eventModel.slots || []).map(slot =>new InterviewEventRequestSlotDto ({
      ...slot,
      peoples: [],
      languages: []
    }));

    this.eventModel = {
      ...this.eventModel,
      players: item.key,
      slots: updatedSlots
    };
    
   this.emitChanges(); 
  }

  getTimeWithInterval(time: moment.Moment) {
    return moment(time).add(5, 'minutes');
  }

  getDurationText(slot: InterviewEventRequestSlotDto) {
    return helper.getTimeStringForTimePicker((slot as any).duration);
  }


  ngOnDestroy(): void {
    if (this.locationSubscription) {
      this.locationSubscription.unsubscribe();
    }
  }
}
